import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { StateDropdown } from './state-dropdown';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';
import { useAddressField } from '../context';

const countriesSupportedByDropdown = ['US', 'AU', 'CA'];

export const StateField = ({ optional = false }) => {
  const { address } = useAddressField(FIELD_NAMES.STATE);
  const { countryCode } = address;

  return countriesSupportedByDropdown.includes(countryCode) ? (
    <StateDropdown />
  ) : (
    <AddressInput autoComplete={AutoCompleteField.AddressLevel1} field={FIELD_NAMES.STATE} optional={optional} />
  );
};

StateField.propTypes = {
  optional: PropTypes.bool,
};
